module.exports = __webpack_public_path__ + "img/slide3_mobile.ca941977.jpg";